<template>
  <div id="checkup-evaluations">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`)},
        { title: this.$t('menu.checkup_plus/evaluations'), disabled: true }
      ]">


      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>
    </Breadcrumbs>

    <EvaluationsTable
      class="mt-1"
      :activeFilters="activeFilters"
      :service="component.service"
      :showFilters="showFilters"
      :readableEntities="readableEntities"
      :readableFacilities="readableFacilities"
      @row-clicked="onAppointmentClicked"
    />
  </div>

</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import Filters from '@/components/common/Filters'
import EvaluationsTable from '@/components/checkup_plus/evaluations/EvaluationsTable.vue';
import PatientsTable from '@/components/checkup_plus/patients/PatientsTable.vue';

export default {
  components: { PatientsTable, EvaluationsTable, Filters, Breadcrumbs },
  props: {
    component: {
      type: Object,
      required: true,
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showFilters: true,
      activeFilters: 0,
    };
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    onAppointmentClicked() {

    }
  },
  computed: {
    checkupPlusService: function () {
      return this.component.service || null
    },
    readableEntities: function () {
      if (!this.checkupPlusService) {
        return []
      }
      let permissions = this.checkupPlusService.user_permissions.filter(
        p => p.info_type === 140 && p.access_type >= this.$store.state.accessTypes.READ
      )

      if (permissions.some(p => p.entity_id === null)) {
        return [...this.checkupPlusService.entities]
      } else {
        return this.checkupPlusService.entities.filter(entity => permissions.some(p => p.entity_id === entity.id))
      }
    },
    readableFacilities: function () {
      if (!this.readableEntities.length) {
        return []
      }
      return this.readableEntities.map(entity => entity.facilities).flat()
    },
  }
};
</script>

<style scoped lang="scss">

</style>
